<h6 class="fw-bold mt-3" i18n>Kontaktdaten</h6>
<p class="text-muted small" i18n>
  Die Kontaktdaten Ihres Kundenkontos — unabhängig von den Anmeldedaten der einzelnen
  Benutzer. Die Kontakt-E-Mail sehen Käufer auf Ihrer Anbieterseite, sie steht auf Ihren
  Rechnungen, und Bestellungen an Sie werden dorthin gemeldet. Ob auch Bestellbestätigungen
  Ihrer eigenen Einkäufe dorthin gehen, legen Sie unter „Einstellungen“ fest.
</p>
<form [formGroup]="contactForm">
  <div class="row">
    <div class="col-sm-8">
      <app-form-row label="Kontakt-E-Mail" i18n-label>
        <input
          id="contactEmail"
          type="email"
          formControlName="email"
          class="form-control form-control-sm"
          data-testid="customer-contact-email"
          />
      </app-form-row>
      <app-form-row label="Telefon" i18n-label>
        <input
          id="contactPhone"
          type="text"
          formControlName="phone"
          class="form-control form-control-sm"
          />
      </app-form-row>
      <app-form-row label="Fax" i18n-label>
        <input
          id="contactFax"
          type="text"
          formControlName="fax"
          class="form-control form-control-sm"
          />
      </app-form-row>
      <app-form-row label="Internet" i18n-label>
        <input
          id="contactInternet"
          type="text"
          formControlName="internet"
          class="form-control form-control-sm"
          />
      </app-form-row>
      <app-form-row label="Beschreibung" i18n-label>
        <textarea
            id="contactDescription"
            rows="4"
            formControlName="description"
            class="form-control form-control-sm"
          ></textarea>
      </app-form-row>
      <button
        type="button"
        class="btn btn-primary"
        data-testid="customer-contact-save"
        [asyncClick]="save(contactForm.value)"
        [disabled]="saveBtn.disabled || contactForm.pristine || !contactForm.valid"
        #saveBtn="asyncClick"
        i18n
        >
        @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
        Speichern
      </button>
    </div>
  </div>
</form>
